
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./Module": () => {
return Promise.all(/*  | __federation_expose_Module */ [__webpack_require__.e("311"), __webpack_require__.e("619"), __webpack_require__.e("173")]).then(() => (() => (__webpack_require__(5456))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };